// theme-sources/js/theme/bootstrap.js

import { logger } from "./core/logger";
import { initShopifyEditor } from "./core/shopify-editor";

import "./components/product-form";
import "./components/cart";
import "./components/cart-drawer";
import "./components/variant-selects";
import "./components/product-selling-plans";
import "./components/ziggy-plan-selector";
import "./components/product-info";
import "./components/quantity-input";
import "./components/quick-add-button";
import "./components/cart-upsell";
import "./components/cart-cross-sells";
import "./components/cart-discount";
import "./components/product-bundle-switch";

import "./components/ziggy-pack";

import "./components/cart-page";

// Controllers UI
import { initThemeController } from "./controllers/theme.controller";

function initAll() {
  logger.info("Theme", "initAll");

  initThemeController();
}

export function bootstrapUI() {
  logger.info("Theme", "init start");

  // Shopify editor helpers
  initShopifyEditor();

  // Init principal
  initAll();

  // Réinitialisation quand Shopify recharge une section
  document.addEventListener("shopify:section:load", () => {
    logger.info("Theme", "section reload");
    initAll();
  });
}
